import claseAlEntrar from "../clase-al-entrar";
import parseHTML from "../dom/funciones/parse_html";
var SwipeIt = require('../swipe-it');
var productoUnico = function () {
    [].forEach.call(document.querySelectorAll('.producto_unico-imagenes > .inner'), function (contenedor) {
        var dataImagenes = contenedor.getAttribute('data-imagenes');
        if (!dataImagenes) {
            return;
        }
        contenedor.removeAttribute('data-imagenes');
        JSON.parse(dataImagenes).forEach(function (x) {
            contenedor.insertAdjacentHTML('beforeend', "<div class=\"producto_unico-imagen\">".concat(x, "</div>"));
        });
        var imagenes = [].slice.call(contenedor.querySelectorAll('.producto_unico-imagen'));
        if (imagenes.length > 1) {
            var navegacion_1 = parseHTML('<div class="producto_unico-navegacion"></div>'), anterior_1 = parseHTML('<button class="producto_unico-anterior">Anterior</button>'), siguiente_1 = parseHTML('<button class="producto_unico-siguiente">Siguiente</button>'), contador_1 = parseHTML('<div class="producto_unico-contador"></div>'), maximo_1 = imagenes.length, actualiza_1 = function (posicion) {
                actual_1 = Math.max(0, Math.min(posicion, maximo_1 - 1));
                imagenes.forEach(function (imagen) { return imagen.style.transform = "translateX(-".concat(actual_1 * 100, "%)"); });
                contador_1.innerHTML = imagenes.map(function (imagen, i) {
                    if (i === actual_1) {
                        return "<span class=\"actual\"><button data-posicion=\"".concat(i, "\">").concat(i + 1, "</button></span>");
                    }
                    else {
                        return "<span><button data-posicion=\"".concat(i, "\">").concat(i + 1, "</button></span>");
                    }
                }).join('');
                anterior_1.setAttribute('aria-disabled', actual_1 === 0 ? 'true' : 'false');
                siguiente_1.setAttribute('aria-disabled', actual_1 === maximo_1 - 1 ? 'true' : 'false');
            };
            contenedor.parentElement.appendChild(navegacion_1);
            navegacion_1.appendChild(anterior_1);
            navegacion_1.appendChild(contador_1);
            navegacion_1.appendChild(siguiente_1);
            navegacion_1.addEventListener('click', function (e) {
                var boton = e.target.closest('button[data-posicion]');
                if (boton) {
                    actualiza_1(parseInt(boton.getAttribute('data-posicion'), 10));
                }
            });
            var actual_1 = 0;
            anterior_1.addEventListener('click', function () { return actualiza_1(actual_1 - 1); });
            siguiente_1.addEventListener('click', function () { return actualiza_1(actual_1 + 1); });
            claseAlEntrar(anterior_1, 'flecha-izquierda');
            claseAlEntrar(siguiente_1, 'flecha-derecha');
            var swipeIt = new SwipeIt(contenedor.parentElement);
            swipeIt.on('swipeLeft', function () { return actualiza_1(actual_1 + 1); });
            swipeIt.on('swipeRight', function () { return actualiza_1(actual_1 - 1); });
            actualiza_1(0);
        }
    });
};
export default productoUnico;
